import config from '@/config'
import { store } from '@/store/store'
import axios from 'axios'

const instance = () =>
  axios.create({
    baseURL: `${config.serverUrl}api/cms/v1`,
    timeout: 30000,
    headers: {
      AUTHORIZATION: store.getters.securityToken
    }
  })

const broadcastApi = {
  getBroadcastLogs: (params) => instance().get('/broadcast-log', { params }),
  getErrorBroadcastLogs: (params) => instance().get('/broadcast-log/error', { params })
}

export default broadcastApi



// WEBPACK FOOTER //
// ./src/api/broadcast.js